module.exports = __webpack_public_path__ + "static/media/pla_ker_mac_pin.2e44e6d0.png";